export default __webpack_public_path__ + "static/media/Gloomshield.57f00567.jpg";